export const EXPAND_BUTTON_TEXT = `Показать еще`;
export const SHRINK_BUTTON_TEXT = `Скрыть`;
